/**
 * The user picker on the login screen. The list is public, so the backend sends no names:
 * each user is a monogram of their username ("RG") and is signed in by id.
 */

export interface LoginUserOption {
    id: number;
    monogram: string;
}

export interface LoginUsersResponse {
    users: LoginUserOption[];
}

/** Who is signing in: the login screen names them by id, the Change User page by username. */
export type LoginIdentity = { userId: number } | { username: string };

export interface LoginUserSelectOption {
    value: number;
    label: string;
}

export const toLoginUserSelectOptions = (
    users: readonly LoginUserOption[] | undefined,
): LoginUserSelectOption[] => (users ?? []).map(user => ({ value: user.id, label: user.monogram }));

const normalizeMonogram = (text: string): string => text.replace(/\s+/g, '').toUpperCase();

/**
 * Whether the typed text picks out the option: monograms are matched from their start, in any
 * case and ignoring spaces, so "rg2" finds "RG 2" and "r" lists every R… monogram.
 */
export const monogramMatchesSearch = (
    search: string,
    option: LoginUserSelectOption | undefined,
): boolean => normalizeMonogram(option?.label ?? '').startsWith(normalizeMonogram(search));
